import {
  BannerResponse,
  BlogNewsData, BlogPageData, ICategoryNews, NewDetail
} from './type';

import axiosInstance from 'services/common/instance';
import { NewsParams } from 'services/systems/types';

export const getNewsService = async () => {
  const res = await axiosInstance.get('news');
  return res.data;
};

export const getNewsBlogService = async ({ endPoint, params }
  : { endPoint: string, params?: NewsParams, blockName?: string }): Promise<BlogNewsData[]> => {
  const res = await axiosInstance.get(endPoint || 'news', {
    params: {
      ...params,
      locale: params?.locale,
      categoryIds: params?.categoryIds?.join(',')
    }
  });
  return res.data.data;
};

export const getNewDetailService = async (params: {
  slug: string;
  locale?: string;
  endPoint?: string
}): Promise<NewDetail> => {
  const res = await axiosInstance.get(`${params.endPoint || 'news'}/${params.slug}`, { params: { locale: params.locale } });
  return res.data.data;
};

export const getBannerService = async (id: number): Promise<BannerResponse> => {
  const response = await axiosInstance.get(`/banners/${id}`);
  return response.data.data;
};

export const getPagesBlogService = async (params: {
  slug: string;
  locale?: string;
}): Promise<BlogPageData> => {
  const res = await axiosInstance.get(`pages/${params.slug}`, { params: { locale: params.locale } });
  return res.data.data;
};

export const getPagesBlogPreviewService = async (params: {
  previewCode: string;
  locale?: string;
}): Promise<BlogPageData> => {
  const res = await axiosInstance.get(`pages/static/preview/${params.previewCode}`, { params: { locale: params.locale } });
  return res.data.data;
};

export const getPreviewNewsService = async (params: {
  previewCode: string;
  locale?: string;
  endPoint?: string
}): Promise<NewDetail> => {
  const res = await axiosInstance.get(`${params.endPoint}/static/preview/${params.previewCode}`, { params: { locale: params.locale } });
  return res.data.data;
};

export const getRelatedNewsByCategorySlugService = async (params: {
  slug: string;
  locale?: string;
}): Promise<ICategoryNews> => {
  const res = await axiosInstance.get(`news-categories/${params.slug}`, { params: { locale: params.locale } });
  return res.data.data;
};
